import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import People from '@material-ui/icons/People';

import LinearProgress from '~/components/LinearProgress';

import Request from '~/providers/Request';
import Paper from '~/components/Paper';
import CurrentUser from '~/contexts/CurrentUser';

import maskCellPhone from '~/utils/maskCellPhone';

function ExamPerson({ history }) {
  const { id } = history.location.route.getParams();
  const { user } = useContext(CurrentUser);
  const [record, setRecord] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingLog, setLoadingLog] = useState(false);
  const { t } = useTranslation();

  async function onSubmit(response) {
    const data = {
      attributes: {
        doctor_id: user.id,
        user_id: id,
        comigo_exam_id: response.id,
      },
    };

    setLoadingLog(true);
    Request.post('/admin/user_exams', { data }, {}, { controller: 'person' })
      .then(() => {
        setLoadingLog(false);
      })
      .catch((e) => {
        console.error(e);
        setLoadingLog(false);
      });
  }

  useEffect(() => {
    setLoading(true);
    Request.get(`/admin/users/${id}`, {})
      .then((response) => {
        const data = response.data;
        setLoading(false);
        setRecord(data);

        let crm_uf = '';
        let crm_number = '';

        // Preferir o registro estruturado; cair no legado (fatiado) so p/ cadastros antigos.
        if (user.crm_numero) {
          crm_number = user.crm_numero;
          crm_uf = user.crm_uf || '';
        } else if (user.crm) {
          crm_uf = user.crm.slice(-2);
          crm_number = user.crm.slice(0, -3);
        }

        const constructor = {
          partnerId:
            process.env.NODE_ENV === 'production'
              ? '41ba2c7d-ed92-4ac7-9a1d-024405fff69c'
              : 'c0821d1c-a265-4275-854e-3ff252ac6035',
          // externalId: '123456', //id da consulta
          doctor: {
            externalId: user.uuid,
            name: user.name,
            // specialty: 4,
            crm: {
              uf: crm_uf,
              number: crm_number,
            },
          },
          patient: {
            externalId: data.uuid,
            name: data.name,
            phone: maskCellPhone(data.cell_phone),
            email: data.email,
          },
          callback: (response) => {
            onSubmit(response);
          },
        };

        new window.ComigoConnect(constructor);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <Paper
        Icon={People}
        iconColor="blue"
        title={` ${t('person.extras.examsPerson')} - ${record.name}`}
        loading={loading}
      >
        <LinearProgress loading={loadingLog} />
        <div data-comigo-launcher> </div>
        <LinearProgress loading={loadingLog} />
      </Paper>
    </div>
  );
}

export default ExamPerson;
